import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import './PaymentSuccess.css';

// PHASE 1: Payment processing disabled
// Payments not accepted during Phase 1

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-result-container">
      <div className="payment-result-card cancel">
        <div className="cancel-icon" aria-hidden="true"><HiOutlineInformationCircle /></div>
        <h1>Payment Not Required</h1>
        <p>All features are free in Phase 1!</p>
        <p className="info-text">
          You don't need to pay for anything. All messaging and features are completely free.
        </p>
        <div className="button-group">
          <button 
            onClick={() => navigate('/discover')}
            className="btn-primary"
          >
            Continue to App
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
